import GridIcon from '@/CustomIcons/GridIcon'
import MenuButton, { MenuItem } from '@/UIComponents2/MenuButton/MenuButton'
import ScreenShareMenuButton from './ShareScreenMenuButton'
import ReactionsMenuButton from './ReactionsMenuButton'
import MusicDevicesMenuButton from './MusicDevicesMenuButton'
import CollaboratorsMenuButton from './CollaboratorsMenuButton'
import RecordingMenuButton from './RecordingMenuButton'
import { ChatMenuButton } from './ChatMenuButton'
import UserVideoMenuButton from './UserVideoMenuButton'
import useChatRoomController from '@/pages/ChatRoom/useChatRoomController'
import { useState } from 'react'
import ReactionOverlay from '../shared/ReactionOverlay'

type OverflowMenuButtonProps = {
    screenShare: boolean
    reactions: boolean
    musicDevices: boolean
    recording: boolean
    invite: boolean
    video: boolean
    chatController?: ReturnType<typeof useChatRoomController>
}
export function OverflowMenuButton(props: OverflowMenuButtonProps) {
    let [isOpen, setIsOpen] = useState(false)
    const triggerClassName = 'h-[42px] rounded-[16px]'
    return (
        <>
            <MenuButton
                onOpenChange={(open) => setIsOpen(open)}
                label="More"
                icon={<GridIcon style={{ fontSize: '1.3rem' }} />}
                zIndex={29} /* Ensures the nested menu buttons are on top of the overflow menu */
                contentClassName="p-0"
                content={
                    <div className="flex flex-col gap-1">
                        {props.screenShare && (
                            <MenuItem>
                                <ScreenShareMenuButton labelPosition="inside" triggerClassName={triggerClassName} />
                            </MenuItem>
                        )}
                        {props.reactions && (
                            <ReactionsMenuButton labelPosition="inside" triggerClassName={triggerClassName} />
                        )}
                        {props.musicDevices && (
                            <MusicDevicesMenuButton labelPosition="inside" triggerClassName={triggerClassName} />
                        )}
                        {props.recording && (
                            <RecordingMenuButton labelPosition="inside" triggerClassName={triggerClassName} />
                        )}
                        {props.invite && (
                            <MenuItem>
                                <CollaboratorsMenuButton labelPosition="inside" triggerClassName={triggerClassName} />
                            </MenuItem>
                        )}
                        {
                            <MenuItem>
                                <ChatMenuButton
                                    labelPosition="inside"
                                    triggerClassName={triggerClassName}
                                    chatController={props.chatController}
                                />
                            </MenuItem>
                        }
                        {props.video && (
                            <UserVideoMenuButton labelPosition="inside" triggerClassName={triggerClassName} />
                        )}
                    </div>
                }
            />
            {!isOpen && <ReactionOverlay userUrn="viewer" />}
        </>
    )
}
